import styled from "styled-components";
import theme from "../../../../../Styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: center;

  justify-content: space-between;
`;

export const Button = styled.button`
  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
  display: flex;
  align-items: center;
  margin-right: 2.5vw;
  margin-left: 2.5vw;
`;
